import {
    chipGreen,
    chipYellow,
    chipOrange,
    chipRed,
} from "../../businessLogic/styles";
import {useTranslation} from "@1f/react-sdk";

export const AutovalutazioneHelpers = () => {
    const { t } = useTranslation();

    const GetAnalisiNMesiById = (id) => {
        switch(id)
        {
            case 0:
                return 6;
            case 1: 
                return 12;
            case 2:
                return 24;
            case 3:
                return 36
            default:
                return 6
        }
    }
    const GetLivelloRischioAndColorByAutovalutazione = (item) => {
        let livelloS = "Nessuna autovalutazione presente per lo studio";
        let livelloC = chipGreen;
        
        if(!item || !item.LivelloRischio){
            return {livelloS, livelloC}
        }
        
        switch (item.LivelloRischio) {
            case 1: {
                livelloS = t("autovalutazione.form.livelloRischio1");
                livelloC = chipGreen;
                break;
            }
            case 2: {
                livelloS = t("autovalutazione.form.livelloRischio2");
                livelloC = chipYellow;
                break;
            }
            case 3: {
                livelloS = t("autovalutazione.form.livelloRischio3");
                livelloC = chipOrange;
                break;
            }
            case 4: {
                livelloS = t("autovalutazione.form.livelloRischio4");
                livelloC = chipRed;
                break;
            }
            default: {
                livelloS = "";
                livelloC = chipGreen;    
                break;
            }
        }

        return {livelloS, livelloC}
    }
    const GetLivelloRischioAndColorByAutovalutazioneAvvocati = (item) => {
        let livelloS = "Nessuna Autovalutazione presente per lo studio"
        let livelloC = chipRed;
        if(item && item.CreatedOn){
            livelloS = `Ultima Autovalutazione presente del ${new Date(item.CreatedOn).toLocaleDateString()}`
            livelloC = chipGreen;
        } 
        return {livelloS, livelloC}
    }
    const GetAutovlutazioneExpire = (autovalutazione,user) => {
        if(autovalutazione && user){
            let itemModel = {
                id: autovalutazione.Id,
                creationDate: autovalutazione.Date,
                expireDate: autovalutazione.ExpireDate,
                providedBy: user?.Name || " " + " " + user?.Surname || "",
            }
            return itemModel;
        }
    }

    return {
        GetAnalisiNMesiById,
        GetLivelloRischioAndColorByAutovalutazione,
        GetLivelloRischioAndColorByAutovalutazioneAvvocati,
        GetAutovlutazioneExpire
    }
}

// Export standalone functions for backward compatibility
export const getAnalisiNMesiById = (id) => {
    switch(id)
    {
        case 0:
            return 6;
        case 1: 
            return 12;
        case 2:
            return 24;
        case 3:
            return 36
        default:
            return 6
    }
}
